export {default} from '../../../core/components/Repository/ImageTab';